<template>
  <div class="automotive-portal">
    <!-- 移动端菜单遮罩层 -->
    <div 
      v-if="mobileMenuOpen" 
      class="mobile-menu-overlay" 
      @click="toggleMobileMenu"
    ></div>
    
    <!-- 左侧导航栏 -->
    <aside v-if="!isProductDetailPage" class="sidebar-nav" :class="{ 'mobile-open': mobileMenuOpen }">
      <div class="logo-section">
        <div class="logo-container" @click="handleLandingClick">
          <h1 class="logo-text">SKYAUTOMAX</h1>
        </div>
        <button
          type="button"
          class="sidebar-close-btn"
          aria-label="Close menu"
          @click.stop="toggleMobileMenu"
        >
          <i class="el-icon-close"></i>
        </button>
      </div>
      <nav class="main-nav">
        <ul class="nav-menu">
          <li class="nav-item" :class="{ active: activeIndex === 'landing' }" @click="handleLandingClick">
            <a href="javascript:void(0)">
              <i class="el-icon-house"></i>
              <span>{{ $t('homeLayout.navHome') }}</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeIndex === 'home' }" @click="handleHomeClick">
            <a href="javascript:void(0)">
              <i class="el-icon-goods"></i>
              <span>{{ $t('homeLayout.navProducts') }}</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeIndex === 'newArrivals' }" @click="handleNewArrivalsClick">
            <a href="javascript:void(0)">
              <i class="el-icon-time"></i>
              <span>{{ $t('homeLayout.navNewArrivals') }}</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeIndex === 'favorites' }" @click="handleFavoritesClick">
            <a href="javascript:void(0)">
              <i class="el-icon-star-off"></i>
              <span>{{ $t('homeLayout.navMyFavorites') }}</span>
            </a>
          </li>
          <li v-if="isFavoritesPage && sidebarMenuList.length === 0" class="nav-item favorites-empty-tip">
            <a href="javascript:void(0)" class="favorites-empty-link">
              <span>{{ $t('homeLayout.favoritesEmptyNav') }}</span>
            </a>
          </li>
          <!-- 动态渲染菜单：首页全量类目 / 收藏页仅收藏类目树 -->
          <li
            v-for="(item, index) in sidebarMenuList"
            :key="item.id"
            class="nav-item"
            :class="{
              'nav-submenu': item.children && item.children.length > 0,
              active: activeIndex === `menu-${item.id}`,
              open: submenuOpen === `menu-${item.id}`
            }"
          >
            <!-- 一级菜单 -->
            <a
              href="javascript:void(0)"
              @click="item.children && item.children.length > 0 ? toggleSubmenu(`menu-${item.id}`) : handleMenuClick(`menu-${item.id}`, item)"
            >
              <i :class="getMenuIcon(item.level, index)"></i>
              <span>{{ item.name }}</span>
              <i
                v-if="item.children && item.children.length > 0"
                class="el-icon-arrow-right"
                :class="{ rotated: submenuOpen === `menu-${item.id}` }"
              ></i>
            </a>
            <!-- 二级菜单 -->
            <ul
              v-if="item.children && item.children.length > 0"
              class="submenu"
              v-show="submenuOpen === `menu-${item.id}`"
            >
              <li
                v-for="child in item.children"
                :key="child.id"
                class="submenu-item"
                :class="{
                  'has-children': child.children && child.children.length > 0,
                  'submenu-open': subSubmenuOpen === `menu-${item.id}-${child.id}`,
                  active: activeIndex === `menu-${item.id}-${child.id}`
                }"
              >
                <a
                  href="javascript:void(0)"
                  @click.stop="child.children && child.children.length > 0 ? toggleSubSubmenu(`menu-${item.id}-${child.id}`) : handleMenuClick(`menu-${item.id}-${child.id}`, child)"
                >
                  <span>{{ child.name }}</span>
                  <i
                    v-if="child.children && child.children.length > 0"
                    class="el-icon-arrow-right submenu-arrow"
                    :class="{ rotated: subSubmenuOpen === `menu-${item.id}-${child.id}` }"
                  ></i>
                </a>
                <!-- 三级菜单 -->
                <ul
                  v-if="child.children && child.children.length > 0"
                  class="sub-submenu"
                  v-show="subSubmenuOpen === `menu-${item.id}-${child.id}`"
                >
                  <li
                    v-for="grandChild in child.children"
                    :key="grandChild.id"
                    class="sub-submenu-item"
                    :class="{
                      active: activeIndex === `menu-${item.id}-${child.id}-${grandChild.id}`
                    }"
                  >
                    <a
                      href="javascript:void(0)"
                      @click.stop="handleLevel3Click(`menu-${item.id}-${child.id}-${grandChild.id}`, grandChild)"
                    >
                      <span>{{ grandChild.name }}</span>
                      <i
                        v-if="grandChild.children && grandChild.children.length > 0"
                        class="el-icon-arrow-right sub-submenu-arrow"
                      ></i>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- 主内容区 -->
    <div class="main-content" :class="{ 'no-sidebar': isProductDetailPage }">
      <!-- 顶部搜索栏 -->
      <header v-if="!isProductDetailPage" class="top-header">
        <div class="header-container">
          <div class="search-box">
            <!-- 手机端：原下拉位置改为导航入口 -->
            <button
              type="button"
              class="mobile-menu-btn"
              :class="{ 'is-open': mobileMenuOpen }"
              aria-label="Menu"
              @click="toggleMobileMenu"
            >
              <span class="menu-btn-lines" aria-hidden="true">
                <i></i>
                <i></i>
                <i></i>
              </span>
            </button>
            <el-input
              v-model="searchQuery"
              :placeholder="$t('homeLayout.placeholderKeyword')"
              class="search-input"
              @keyup.enter.native="handleSearch"
            >
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div>
          <div class="user-actions">
            <el-button type="text" @click="showLoginDialog" v-if="!isLoggedIn" class="action-btn">
              <i class="el-icon-user"></i> {{ $t('homeLayout.login') }}
            </el-button>
            <div v-else class="user-info" @click="showUserInfoDialog">
              <i class="el-icon-user"></i>
              <span>{{ $store.getters.name || $t('common.user') }}</span>
            </div>
            <el-button type="text" @click="goToLogin" v-if="!isLoggedIn" class="action-btn header-cart-btn">
              <i class="el-icon-shopping-cart-full"></i> {{ $t('homeLayout.inquiry') }}
            </el-button>
            <el-select v-if="showLanguageSwitcher" class="lang-select" :value="language" @change="handleLanguageChange" size="mini">
              <el-option label="English" value="en-US"></el-option>
              <el-option label="简体中文" value="zh-CN"></el-option>
            </el-select>
          </div>
        </div>
      </header>

      <!-- 面包屑导航 -->
      <div class="breadcrumb-container" v-if="!isProductDetailPage && breadcrumbItems.length > 0">
        <div class="breadcrumb-row">
          <el-breadcrumb separator=">">
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumbItems"
              :key="index"
            >
              <!-- 最后一项：如果是产品名称，显示为不可点击的当前项 -->
              <span
                v-if="index === breadcrumbItems.length - 1 && item.type === 'product'"
                class="breadcrumb-current"
              >{{ item.name }}</span>
              <!-- 最后一项：如果是分类（商品列表页的最后一级分类），显示为可点击 -->
              <a
                v-else-if="index === breadcrumbItems.length - 1 && item.type === 'category'"
                href="javascript:void(0)"
                @click="handleBreadcrumbClick(item)"
                class="breadcrumb-link breadcrumb-current"
              >{{ item.name }}</a>
              <!-- 倒数第二项：如果是分类且在商品详情页（前面有产品名称），显示为可点击 -->
              <a
                v-else-if="index === breadcrumbItems.length - 2 && item.type === 'category' && breadcrumbItems[breadcrumbItems.length - 1].type === 'product'"
                href="javascript:void(0)"
                @click="handleBreadcrumbClick(item)"
                class="breadcrumb-link"
              >{{ item.name }}</a>
              <!-- 前面的分类（不可点击） -->
              <span
                v-else
                class="breadcrumb-text"
              >{{ item.name }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <button
            v-if="showCategoryFavoriteStar"
            type="button"
            class="category-favorite-star"
            :class="{ active: categoryFavorited }"
            :title="categoryFavorited ? $t('homeLayout.unfavoriteCategory') : $t('homeLayout.favoriteCategory')"
            :disabled="categoryFavoriteLoading"
            @click="toggleCategoryFavorite"
          >
            <i :class="categoryFavorited ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          </button>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content-wrapper" ref="contentWrapper">
        <keep-alive :include="['AutomotivePortal', 'ProductDetail']">
          <router-view :key="activeTabId || $route.path"></router-view>
        </keep-alive>
      </div>
    </div>

    <!-- 底部悬浮询价栏（与手机端一致，登录且有商品时显示） -->
    <transition name="float-cart-slide">
      <div
        v-show="showFloatingCart"
        class="floating-cart-bar"
      >
        <div class="float-cart-main" @click="showCartDialog">
          <div class="float-cart-icon-wrap">
            <i class="el-icon-shopping-cart-full"></i>
            <span class="float-cart-badge">{{ cartCount > 99 ? '99+' : cartCount }}</span>
          </div>
          <div class="float-cart-info">
            <div class="float-cart-title">
              <span class="float-cart-count">{{ $t('cart.selectedItems', { count: cartCount }) }}</span>
              <span class="float-cart-details">
                {{ $t('homeLayout.floatingCartDetails') }}
                <i class="el-icon-arrow-up"></i>
              </span>
            </div>
            <div class="float-cart-sub">
              <template v-if="cartCBMTotal > 0">
                {{ $t('cart.totalCbm') }} {{ cartCBMTotalFormatted }}
              </template>
              <template v-else>
                {{ $t('cart.inquiryTitle') }}
              </template>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="float-cart-checkout"
          @click.stop="handleFloatingCheckout"
        >
          {{ $t('cart.checkout') }}
        </button>
      </div>
    </transition>

    <!-- 询价单对话框 -->
    <CartDialog
      :visible.sync="cartDialogVisible"
      @cart-count-change="handleCartCountChange"
      @checkout="handleCheckout"
    />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { fetchCategoryTreeList } from '@/api/productCate';
import { getCartList } from '@/api/cart';
import {
  addCategoryCollection,
  deleteCategoryCollection,
  getCategoryCollectionDetail,
  listAllCategoryCollections
} from '@/api/categoryCollection';
import CartDialog from '@/components/CartDialog';

export default {
  name: 'HomeLayout',
  components: {
    CartDialog
  },
  data() {
    return {
      activeIndex: 'home',
      searchQuery: '',
      searchType: 'keyword', // 搜索类型：keyword, oemNumber, partNumber
      isLoggedIn: false,
      submenuOpen: '',
      subSubmenuOpen: '',
      menuList: [],
      favoriteCategoryIds: [],
      categoryFavorited: false,
      categoryFavoriteLoading: false,
      pendingGoFavoritesAfterLogin: false,
      loading: false,
      mobileMenuOpen: false, // 移动端菜单打开状态
      cartCount: 0,
      cartList: [], // 询价单商品列表（用于计算CBM）
      cartDialogVisible: false,
      currentProductInfo: null, // 当前产品信息，用于面包屑
      activeTabId: null // 当前激活的标签页ID
    };
  },
  computed: {
    // 判断是否是产品详情页
    isProductDetailPage() {
      return this.$route.name === 'productDetail';
    },
    isFavoritesPage() {
      return this.$route.name === 'favorites';
    },
    isLandingPage() {
      return this.$route.name === 'landing';
    },
    sidebarMenuList() {
      if (this.isFavoritesPage) {
        return this.buildFavoriteMenuTree(this.menuList, this.favoriteCategoryIds);
      }
      return this.menuList;
    },
    currentBreadcrumbCategoryId() {
      if (this.$route.name === 'home' || this.$route.name === 'favorites') {
        const id = this.$route.query.categoryId;
        return id ? parseInt(id, 10) : null;
      }
      if (this.$route.name === 'productDetail') {
        const id = this.$route.query.categoryId ||
          (this.currentProductInfo && this.currentProductInfo.product && this.currentProductInfo.product.productCategoryId);
        return id ? parseInt(id, 10) : null;
      }
      return null;
    },
    showCategoryFavoriteStar() {
      return !!this.currentBreadcrumbCategoryId && this.breadcrumbItems.some(item => item.type === 'category');
    },
    // 生成面包屑数据
    breadcrumbItems() {
      const items = [];
      
      // 如果是商品详情页
      if (this.$route.name === 'productDetail' && this.$route.params.id) {
        // 优先使用路由参数中的 categoryId
        const categoryId = this.$route.query.categoryId || 
                          (this.currentProductInfo && this.currentProductInfo.product && this.currentProductInfo.product.productCategoryId);
        if (categoryId) {
          // 构建分类路径
          const categoryPathWithIds = this.buildCategoryPathWithIds(parseInt(categoryId));
          categoryPathWithIds.forEach((item) => {
            items.push({
              name: item.name,
              type: 'category',
              categoryId: item.id
            });
          });
        }
        
        // 添加产品名称
        if (this.currentProductInfo && this.currentProductInfo.product) {
          items.push({
            name: this.currentProductInfo.product.name,
            type: 'product',
            productId: this.$route.params.id
          });
        } else {
          // 如果没有产品信息，显示占位文本
          items.push({
            name: this.$t('homeLayout.productDetailFallback'),
            type: 'product',
            productId: this.$route.params.id
          });
        }
      }
      // 如果是首页或收藏页且有分类ID
      else if ((this.$route.name === 'home' || this.$route.name === 'favorites') && this.$route.query.categoryId) {
        const categoryId = parseInt(this.$route.query.categoryId);
        const categoryPathWithIds = this.buildCategoryPathWithIds(categoryId);
        categoryPathWithIds.forEach((item) => {
          items.push({
            name: item.name,
            type: 'category',
            categoryId: item.id
          });
        });
      }
      
      return items;
    },
    // 询价单CBM总和
    cartCBMTotal() {
      if (!this.cartList || this.cartList.length === 0) return 0;
      
      let total = 0;
      this.cartList.forEach(item => {
        const cbm = this.getItemCBM(item);
        if (cbm) {
          total += parseFloat(cbm);
        }
      });
      
      return total;
    },
    // 询价单CBM总和（格式化显示）
    cartCBMTotalFormatted() {
      const total = this.cartCBMTotal;
      return total > 0 ? total.toFixed(4) : '0.0000';
    },
    language() {
      return this.$store.getters.language
    },
    showLanguageSwitcher() {
      return process.env.ENABLE_I18N_SWITCH !== 'false'
    },
    inquiryText() {
      const cbmPart = this.cartCBMTotal > 0
        ? this.$t('homeLayout.cartCbmSuffix', { value: this.cartCBMTotalFormatted })
        : ''
      return this.$t('homeLayout.inquiryWithCount', {
        count: this.cartCount,
        cbm: cbmPart
      })
    },
    // 底部悬浮询价栏：有商品且未打开询价单弹框时显示
    showFloatingCart() {
      return this.isLoggedIn && this.cartCount > 0 && !this.cartDialogVisible;
    }
  },
  created() {
    this.isLoggedIn = !!getToken();
    if (this.isLoggedIn) {
      this.fetchCartCount();
      this.loadFavoriteCategoryIds();
    }
    this.fetchMenuList();
    // 初始化搜索类型和搜索内容（根据当前路由参数）
    this.initSearchFromRoute();
    this.syncCategoryFavoriteState();
    // 监听登录成功事件
    this.$root.$on('login-success', () => {
      this.isLoggedIn = true;
      this.fetchCartCount();
      this.loadFavoriteCategoryIds().then(() => {
        this.syncCategoryFavoriteState();
        if (this.pendingGoFavoritesAfterLogin) {
          this.pendingGoFavoritesAfterLogin = false;
          this.$router.push({ path: '/favorites' }).catch(() => {}).finally(() => {
            this.ensureMobileNavOpenForFavorites();
          });
        }
      });
    });
    // 监听询价单数量变化事件
    this.$root.$on('cart-count-change', (cartData) => {
      // 如果传递的是对象（包含count和list），直接使用数据，避免重复请求
      if (cartData && typeof cartData === 'object' && cartData.count !== undefined) {
        this.cartCount = cartData.count;
        this.cartList = cartData.list || [];
      } else if (cartData !== undefined && cartData !== null) {
        // 兼容旧格式：只传递了数量
        this.cartCount = cartData;
        // 如果没有列表数据，才调用接口获取（用于计算CBM）
        this.fetchCartCount();
      } else {
        // 没有传递数据，调用接口获取
        this.fetchCartCount();
      }
    });
    // 监听 localStorage 的 storage 事件，实现跨窗口购物车数量同步
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    this.$root.$off('login-success');
    this.$root.$off('cart-count-change');
    // 移除 storage 事件监听
    window.removeEventListener('storage', this.handleStorageChange);
    if (typeof document !== 'undefined') {
      document.body.classList.remove('has-floating-cart');
    }
  },
  methods: {
    // 获取菜单列表
    fetchMenuList() {
      this.loading = true;
      fetchCategoryTreeList().then(response => {
        this.loading = false;
        if (response.code === 200 && response.data) {
          // 过滤只显示导航状态为1的菜单
          const filterNavItems = (items) => {
            return items
              .filter(item => item.navStatus === 1)
              .map(item => {
                if (item.children && item.children.length > 0) {
                  item.children = filterNavItems(item.children);
                }
                return item;
              });
          };
          this.menuList = filterNavItems(response.data);
          this.syncSidebarActiveByRoute(this.$route);
        }
      }).catch(error => {
        this.loading = false;
        console.error('获取菜单列表失败:', error);
      });
    },
    // 处理询价单数量变化事件（如果传递了数量，直接使用；否则才调用接口）
    handleCartCountChange(cartCount) {
      if (cartCount !== undefined && cartCount !== null) {
        // 如果事件传递了数量，直接使用，避免重复请求
        this.cartCount = cartCount;
        // 注意：这里不调用 fetchCartCount，因为全局监听器会处理
        // 避免重复调用接口
      } else {
        // 如果没有传递数量，才调用接口
        this.fetchCartCount();
      }
    },
    // 获取询价单数量
    fetchCartCount() {
      if (!this.isLoggedIn) {
        this.cartCount = 0;
        this.cartList = [];
        return Promise.resolve();
      }
      return getCartList().then(res => {
        let list = [];
        if (res.code === 200 || res.code === 0) {
          if (Array.isArray(res.data)) {
            list = res.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            list = res.data.list;
          } else if (res.data && Array.isArray(res.data.data)) {
            list = res.data.data;
          }
        } else if (Array.isArray(res)) {
          list = res;
        }
        // 保存询价单列表（用于计算CBM）
        this.cartList = list;
        // 计算询价单商品总数量（所有商品的 quantity 之和）
        this.cartCount = list.reduce((total, item) => {
          return total + (parseInt(item.quantity) || 1);
        }, 0);
      }).catch(error => {
        console.error('获取询价单数量失败:', error);
        this.cartCount = 0;
        this.cartList = [];
      });
    },
    // 切换子菜单
    toggleSubmenu(index) {
      if (this.submenuOpen === index) {
        this.submenuOpen = '';
      } else {
        this.submenuOpen = index;
      }
    },
    // 切换三级子菜单
    toggleSubSubmenu(index) {
      if (this.subSubmenuOpen === index) {
        this.subSubmenuOpen = '';
      } else {
        this.subSubmenuOpen = index;
      }
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    // 获取菜单图标
    getMenuIcon(level, index) {
      const icons = ['el-icon-menu', 'el-icon-goods', 'el-icon-present'];
      return icons[index % icons.length];
    },
    // 点击门户首页
    handleLandingClick() {
      this.activeIndex = 'landing';
      if (this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
      this.$router.push('/');
    },
    // 点击产品目录
    handleHomeClick() {
      this.activeIndex = 'home';
      if (this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
      this.$router.push('/home');
    },
    handleNewArrivalsClick() {
      this.activeIndex = 'newArrivals';
      if (this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
      this.$router.push('/new-arrivals');
    },
    // 点击我的收藏
    handleFavoritesClick() {
      if (!this.isLoggedIn) {
        this.$message.warning(this.$t('homeLayout.loginFirst'));
        this.pendingGoFavoritesAfterLogin = true;
        this.$root.$emit('show-login-dialog');
        return;
      }
      this.activeIndex = 'favorites';
      // 收藏页默认无商品列表，手机端保持导航展开，便于继续点选收藏类目
      this.loadFavoriteCategoryIds();
      this.$router.push({ path: '/favorites' }).catch(() => {}).finally(() => {
        this.ensureMobileNavOpenForFavorites();
      });
    },
    ensureMobileNavOpenForFavorites() {
      if (typeof window === 'undefined' || window.innerWidth > 768) return;
      if (this.$route.name === 'favorites' && !this.$route.query.categoryId) {
        this.mobileMenuOpen = true;
      }
    },
    // 点击菜单（叶子：1/2 级无子，或兼容）
    handleMenuClick(index, item) {
      this.activeIndex = index;
      if (this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
      const targetPath = this.isFavoritesPage ? '/favorites' : '/home';
      this.$router.push({
        path: targetPath,
        query: { categoryId: item.id }
      });
    },
    // 三级：有子级（年份）→ 右侧年份列表；无子级 → 产品列表
    handleLevel3Click(index, item) {
      this.activeIndex = index;
      if (this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
      const targetPath = this.isFavoritesPage ? '/favorites' : '/home';
      const hasYears = item.children && item.children.length > 0;
      this.$router.push({
        path: targetPath,
        query: hasYears
          ? { categoryId: item.id, view: 'years' }
          : { categoryId: item.id }
      });
    },
    buildFavoriteMenuTree(menuList, favoriteIds) {
      const idSet = new Set((favoriteIds || []).map(id => Number(id)));
      if (!idSet.size || !Array.isArray(menuList)) {
        return [];
      }
      const prune = (nodes) => {
        const result = [];
        (nodes || []).forEach(node => {
          const children = node.children && node.children.length ? prune(node.children) : [];
          const selfFavorite = idSet.has(Number(node.id));
          if (selfFavorite || children.length > 0) {
            result.push({
              ...node,
              children
            });
          }
        });
        return result;
      };
      return prune(menuList);
    },
    loadFavoriteCategoryIds() {
      if (!getToken()) {
        this.favoriteCategoryIds = [];
        return Promise.resolve([]);
      }
      return listAllCategoryCollections()
        .then(res => {
          if (res.code === 200 || res.code === 0) {
            const list = Array.isArray(res.data) ? res.data : [];
            this.favoriteCategoryIds = list
              .map(item => item.categoryId)
              .filter(id => id !== undefined && id !== null);
          } else {
            this.favoriteCategoryIds = [];
          }
          return this.favoriteCategoryIds;
        })
        .catch(() => {
          this.favoriteCategoryIds = [];
          return [];
        });
    },
    syncCategoryFavoriteState() {
      const categoryId = this.currentBreadcrumbCategoryId;
      if (!categoryId || !getToken()) {
        this.categoryFavorited = false;
        return Promise.resolve();
      }
      return getCategoryCollectionDetail(categoryId)
        .then(res => {
          if (res.code === 200 || res.code === 0) {
            this.categoryFavorited = !!res.data;
          } else {
            this.categoryFavorited = false;
          }
        })
        .catch(() => {
          this.categoryFavorited = false;
        });
    },
    toggleCategoryFavorite() {
      const categoryId = this.currentBreadcrumbCategoryId;
      if (!categoryId) return;
      if (!this.isLoggedIn) {
        this.$message.warning(this.$t('homeLayout.loginFirst'));
        this.$root.$emit('show-login-dialog');
        return;
      }
      if (this.categoryFavoriteLoading) return;
      this.categoryFavoriteLoading = true;
      const req = this.categoryFavorited
        ? deleteCategoryCollection(categoryId)
        : addCategoryCollection({ categoryId });
      req
        .then(res => {
          if (res.code === 200 || res.code === 0) {
            this.categoryFavorited = !this.categoryFavorited;
            this.$message.success(
              this.categoryFavorited
                ? this.$t('homeLayout.favoriteSuccess')
                : this.$t('homeLayout.unfavoriteSuccess')
            );
            return this.loadFavoriteCategoryIds().then(() => {
              if (this.isFavoritesPage && !this.categoryFavorited) {
                this.$router.replace({ path: '/favorites' }).catch(() => {});
              }
            });
          }
          this.$message.error(
            this.categoryFavorited
              ? this.$t('homeLayout.unfavoriteFailed')
              : this.$t('homeLayout.favoriteFailed')
          );
        })
        .catch(() => {
          this.$message.error(
            this.categoryFavorited
              ? this.$t('homeLayout.unfavoriteFailed')
              : this.$t('homeLayout.favoriteFailed')
          );
        })
        .finally(() => {
          this.categoryFavoriteLoading = false;
        });
    },
    // 搜索（统一走搜索引擎 keyword）
    handleSearch() {
      const keyword = this.searchQuery.trim();
      if (!keyword) return;
      this.$router.push({
        path: '/home',
        query: { keyword }
      });
    },
    // 显示登录对话框
    showLoginDialog() {
      // 触发全局事件，显示登录对话框（和购物车未登录时弹出的对话框一样）
      this.$root.$emit('show-login-dialog');
    },
    // 显示用户信息对话框
    showUserInfoDialog() {
      // 在新窗口打开个人信息页面
      const route = this.$router.resolve({ path: '/user/profile' });
      const profileUrl = window.location.origin + route.href;
      window.open(profileUrl, '_blank');
    },
    // 跳转到登录
    goToLogin() {
      this.showLoginDialog();
    },
    // 显示询价单对话框
    showCartDialog() {
      if (!this.isLoggedIn) {
        this.$message.warning(this.$t('homeLayout.loginFirst'));
        this.$root.$emit('show-login-dialog');
        return;
      }
      this.cartDialogVisible = true;
    },
    // 底部悬浮栏「去结算」
    handleFloatingCheckout() {
      if (!this.isLoggedIn) {
        this.$message.warning(this.$t('homeLayout.loginFirst'));
        this.$root.$emit('show-login-dialog');
        return;
      }
      const run = () => {
        const ids = (this.cartList || [])
          .map(item => item.id)
          .filter(id => id !== undefined && id !== null);
        if (!ids.length) {
          this.showCartDialog();
          return;
        }
        this.handleCheckout(ids);
      };
      if (!this.cartList || this.cartList.length === 0) {
        this.fetchCartCount().then(run);
        return;
      }
      run();
    },
    handleLanguageChange(language) {
      this.$store.dispatch('SetLanguage', language)
    },
    // 处理结算
    handleCheckout(selectedCartIds) {
      this.cartDialogVisible = false;

      const startCheckout = () => {
        const emitCheckout = () => {
          this.$root.$emit('process-checkout', selectedCartIds);
        };

        if (this.$route.path !== '/home') {
          this.$router.push({ path: '/home' }).then(emitCheckout).catch(emitCheckout);
        } else {
          emitCheckout();
        }
      };

      // 等待询价单对话框关闭动画完成后再触发结算，避免遮罩层冲突
      setTimeout(startCheckout, 350);
    },
    // 构建分类路径（返回包含id和name的数组）
    buildCategoryPathWithIds(categoryId) {
      if (!categoryId || !this.menuList || this.menuList.length === 0) {
        return [];
      }
      const targetId = Number(categoryId);
      
      // 递归查找类目及其父级
      const findCategory = (items, parentPath = []) => {
        for (const item of items) {
          const currentPath = [...parentPath, { id: item.id, name: item.name }];
          if (Number(item.id) === targetId) {
            return currentPath;
          }
          if (item.children && item.children.length > 0) {
            const found = findCategory(item.children, currentPath);
            if (found) {
              return found;
            }
          }
        }
        return null;
      };
      
      const result = findCategory(this.menuList);
      return result || [];
    },
    // 根据类目ID同步侧栏选中与展开（四级高亮其父三级，左侧不展示四级）
    syncMenuActiveFromCategoryId(categoryId) {
      const path = this.buildCategoryPathWithIds(categoryId);
      if (!path.length) {
        return false;
      }
      // 路径超过 3 级时，侧栏只高亮到第 3 级
      const sidebarPath = path.length > 3 ? path.slice(0, 3) : path;
      this.activeIndex = `menu-${sidebarPath.map(item => item.id).join('-')}`;
      this.submenuOpen = sidebarPath[0] ? `menu-${sidebarPath[0].id}` : '';
      this.subSubmenuOpen = sidebarPath.length >= 2
        ? `menu-${sidebarPath[0].id}-${sidebarPath[1].id}`
        : '';
      return true;
    },
    syncSidebarActiveByRoute(route = this.$route) {
      if (!route) return;
      if (route.name === 'home' || route.name === 'favorites' || route.name === 'newArrivals') {
        if (route.query.categoryId) {
          const ok = this.syncMenuActiveFromCategoryId(route.query.categoryId);
          if (!ok) {
            this.activeIndex = route.name === 'favorites'
              ? 'favorites'
              : (route.name === 'newArrivals' ? 'newArrivals' : 'home');
          }
          return;
        }
        this.activeIndex = route.name === 'favorites'
          ? 'favorites'
          : (route.name === 'newArrivals' ? 'newArrivals' : 'home');
        return;
      }
      if (route.path === '/') {
        this.activeIndex = 'landing';
      }
    },
    // 构建分类路径（仅返回名称数组）
    buildCategoryPath(categoryId) {
      const pathWithIds = this.buildCategoryPathWithIds(categoryId);
      return pathWithIds.map(item => item.name);
    },
    // 处理面包屑点击
    handleBreadcrumbClick(item) {
      if (item.type === 'category' && item.categoryId) {
        const targetPath = this.isFavoritesPage ? '/favorites' : '/home';
        const node = this.findCategoryNodeById(item.categoryId);
        const hasYears = node && node.level === 2 && node.children && node.children.length > 0;
        const query = hasYears
          ? { categoryId: item.categoryId, view: 'years' }
          : { categoryId: item.categoryId };
        this.$router.push({
          path: targetPath,
          query
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('导航失败:', err);
          }
        });
      } else if (item.type === 'product' && item.productId) {
        // 跳转到产品详情页（如果需要）
        this.$router.push({
          name: 'productDetail',
          params: { id: item.productId },
          query: this.$route.query.categoryId ? { categoryId: this.$route.query.categoryId } : {}
        }).catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('导航失败:', err);
          }
        });
      }
    },
    findCategoryNodeById(categoryId) {
      const targetId = Number(categoryId);
      const find = (items) => {
        for (const item of items || []) {
          if (Number(item.id) === targetId) {
            return item;
          }
          if (item.children && item.children.length) {
            const found = find(item.children);
            if (found) return found;
          }
        }
        return null;
      };
      return find(this.menuList);
    },
    // 获取产品详情信息（用于面包屑）
    async fetchProductInfo(productId) {
      if (!productId) {
        this.currentProductInfo = null;
        return;
      }
      
      try {
        const { publicRequest } = await import('@/utils/request');
        const res = await publicRequest({
          url: `/product/detail/${productId}`,
          method: 'get'
        });
        
        if (res.code === 200 && res.data) {
          this.currentProductInfo = res.data;
        }
      } catch (error) {
        console.error('获取产品信息失败:', error);
        this.currentProductInfo = null;
      }
    },
    // 根据路由参数初始化搜索内容
    initSearchFromRoute() {
      const query = this.$route.query;
      this.searchQuery = query.keyword || query.oemNumber || query.partNumber || '';
      this.searchType = 'keyword';
    },
    // 获取商品的CBM值（考虑数量）
    getItemCBM(item) {
      if (!item || !item.productAttributeVoList || !Array.isArray(item.productAttributeVoList)) {
        return null;
      }
      
      // 查找长度、宽度、高度属性
      const lengthAttr = this.findAttributeInList(item.productAttributeVoList, ['长度', '长', 'length', 'Length']);
      const widthAttr = this.findAttributeInList(item.productAttributeVoList, ['宽度', '宽', 'width', 'Width']);
      const heightAttr = this.findAttributeInList(item.productAttributeVoList, ['高度', '高', 'height', 'Height']);
      
      // 如果长度、宽度、高度都存在且值不为空，计算CBM
      if (lengthAttr && widthAttr && heightAttr) {
        const length = this.parseNumber(lengthAttr.value);
        const width = this.parseNumber(widthAttr.value);
        const height = this.parseNumber(heightAttr.value);
        
        if (length > 0 && width > 0 && height > 0) {
          // 计算单个商品的CBM = (长 × 宽 × 高) ÷ 1000000
          const singleCbm = (length * width * height) / 1000000;
          // 向上保留小数点后4位
          const singleCbmValue = this.ceilToDecimalPlaces(singleCbm, 4);
          
          // 根据数量计算总CBM（如果数量*2，则CBM也*2）
          const quantity = parseInt(item.quantity) || 1;
          const totalCbm = singleCbmValue * quantity;
          
          return totalCbm.toFixed(4);
        }
      }
      
      return null;
    },
    // 在属性列表中查找属性（支持多个可能的名称）
    findAttributeInList(attributeList, possibleNames) {
      if (!attributeList || !Array.isArray(attributeList)) return null;
      
      // 遍历可能的名称
      for (const name of possibleNames) {
        // 在属性列表中查找匹配的属性
        const attr = attributeList.find(
          a => a.name && a.name.toLowerCase() === name.toLowerCase()
        );
        if (attr && attr.value && String(attr.value).trim() !== '') {
          return attr;
        }
      }
      
      return null;
    },
    // 解析数字（从字符串中提取数字）
    parseNumber(value) {
      if (!value) return 0;
      // 移除所有非数字字符（保留小数点）
      const numStr = String(value).replace(/[^\d.]/g, '');
      const num = parseFloat(numStr);
      return isNaN(num) ? 0 : num;
    },
    // 向上取整到指定小数位
    ceilToDecimalPlaces(num, decimalPlaces) {
      const multiplier = Math.pow(10, decimalPlaces);
      return Math.ceil(num * multiplier) / multiplier;
    },
    // 处理 localStorage storage 事件，实现跨窗口购物车数量同步
    handleStorageChange(event) {
      // 当其他窗口更新购物车时，localStorage 的 cart-updated 会变化
      if (event.key === 'cart-updated' && event.newValue) {
        // 重新获取购物车数量
        if (this.isLoggedIn) {
          this.fetchCartCount();
        }
      }
    }
  },
  watch: {
    showFloatingCart: {
      immediate: true,
      handler(visible) {
        if (typeof document === 'undefined') return;
        document.body.classList.toggle('has-floating-cart', !!visible);
      }
    },
    // 监听路由变化
    '$route'(to) {
      if (to.name === 'favorites') {
        if (!getToken()) {
          this.$message.warning(this.$t('homeLayout.loginFirst'));
          this.pendingGoFavoritesAfterLogin = true;
          this.$root.$emit('show-login-dialog');
          this.$router.replace({ path: '/home' });
          return;
        }
        this.loadFavoriteCategoryIds();
      }
      // 按类目同步选中，避免被重置为 home/favorites
      this.syncSidebarActiveByRoute(to);
      // 如果是产品详情页，获取产品信息
      if (to.name === 'productDetail' && to.params.id) {
        this.fetchProductInfo(to.params.id);
      } else {
        this.currentProductInfo = null;
      }
      this.syncCategoryFavoriteState();
      
      // 根据路由参数更新搜索内容
      const query = to.query;
      if (query.keyword || query.oemNumber || query.partNumber) {
        this.searchQuery = query.keyword || query.oemNumber || query.partNumber || '';
        this.searchType = 'keyword';
      } else if (to.name === 'home' && !query.categoryId) {
        this.searchQuery = '';
        this.searchType = 'keyword';
      }
    },
    currentBreadcrumbCategoryId() {
      this.syncCategoryFavoriteState();
    }
  }
};
</script>

<style scoped lang="scss">
.automotive-portal {
  min-height: 100vh;
  background-color: #f5f5f5;
}

// 左侧导航栏
.sidebar-nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 250px;
  height: 100vh;
  background: #fff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;

  .logo-section {
    padding: 20px;
    border-bottom: 1px solid #e4e7ed;
    position: relative;
    
      .logo-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      
      .logo-image {
        width: 60px;
        height: 60px;
        object-fit: contain;
        display: block;
      }
      
      .logo-text {
        font-size: 20px;
        font-weight: bold;
        color: #DC143C;
        margin: 0;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .sidebar-close-btn {
      display: none;
    }
  }

  .main-nav {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0;
    
    .nav-menu {
      list-style: none;
      margin: 0;
      padding: 0;
      
      .nav-item {
        margin: 5px 0;

        &.favorites-empty-tip {
          pointer-events: none;

          a {
            color: #909399;
            font-size: 13px;
            cursor: default;

            &:hover {
              background: transparent;
              color: #909399;
            }
          }
        }
        
        a {
          display: flex;
          align-items: center;
          padding: 12px 20px;
          color: #303133;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s;
          position: relative;
          
          i {
            margin-right: 12px;
            font-size: 18px;
            width: 20px;
            text-align: center;
          }
          
          .el-icon-arrow-right {
            margin-left: auto;
            transition: transform 0.3s;
            
            &.rotated {
              transform: rotate(90deg);
            }
          }
          
          &:hover {
            background: #f5f7fa;
            color: #DC143C;
          }
        }
        
        &.active a {
          color: #DC143C;
          background: #fff5f5;
          
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: #DC143C;
          }
        }
        
        &.nav-submenu {
          .submenu {
            list-style: none;
            margin: 0;
            padding: 0;
            background: #f5f7fa;
            
            li {
              margin: 0;
              
              a {
                padding-left: 52px;
                font-size: 14px;
                color: #606266;
                display: flex;
                align-items: center;
                justify-content: space-between;
                
                .submenu-arrow {
                  margin-left: auto;
                  margin-right: 0;
                  font-size: 12px;
                  transition: transform 0.3s;
                  
                  &.rotated {
                    transform: rotate(90deg);
                  }
                }
                
                &:hover {
                  background: #e4e7ed;
                  color: #DC143C;
                }
              }
              
              &.has-children {
                position: relative;
                
                &.submenu-open > a {
                  color: #DC143C;
                  background: #e4e7ed;
                }
              }

              &.active > a {
                color: #DC143C;
                background: #fff5f5;
                font-weight: 600;
              }
              
              // 三级菜单样式
              .sub-submenu {
                list-style: none;
                margin: 0;
                padding: 0;
                background: #e9ecef;
                
                .sub-submenu-item {
                  margin: 0;
                  position: relative;
                  
                  a {
                    padding-left: 72px;
                    font-size: 13px;
                    color: #909399;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    
                    .sub-submenu-arrow {
                      margin-left: auto;
                      margin-right: 0;
                      font-size: 11px;
                      transition: transform 0.3s;
                      
                      &.rotated {
                        transform: rotate(90deg);
                      }
                    }
                    
                    &:hover {
                      background: #d3d4d6;
                      color: #DC143C;
                    }
                  }
                  
                  &.has-children {
                    position: relative;
                    
                    &.sub-submenu-open > a {
                      color: #DC143C;
                      background: #d3d4d6;
                    }
                  }

                  &.active > a {
                    color: #DC143C;
                    background: #fff5f5;
                    font-weight: 600;
                  }
                  
                  // 四级菜单样式
                  .sub-sub-submenu {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    background: #dee2e6;
                    
                    li,
                    .sub-sub-submenu-item {
                      margin: 0;
                      
                      a {
                        padding-left: 92px;
                        font-size: 12px;
                        color: #6c757d;
                        
                        &:hover {
                          background: #ced4da;
                          color: #DC143C;
                        }
                      }

                      &.active > a {
                        color: #DC143C;
                        background: #fff5f5;
                        font-weight: 600;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// 主内容区
.main-content {
  margin-left: 250px;
  min-height: 100vh;
  background-color: #f5f5f5;
  
  &.no-sidebar {
    margin-left: 0;
  }
}

// 顶部搜索栏
.top-header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 15px 30px;
  position: sticky;
  top: 0;
  z-index: 1001;
  width: 100%;
  
  .header-container {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
  }
  
  .search-box {
    flex: 1;
    max-width: 600px;
    display: flex;
    align-items: center;
    gap: 10px;
    
    .search-input {
      flex: 1;
      min-width: 0;
    }
  }
  
  .user-actions {
    display: flex;
    align-items: center;
    gap: 15px;

    .header-cart-btn {
      display: none !important;
    }

      .lang-select {
        width: 110px;
      }
    
    .action-btn {
      font-size: 14px;
      color: #303133;
      
      i {
        margin-right: 5px;
      }
      
      &:hover {
        color: #DC143C;
      }
      
      .cart-cbm-text {
        color: #409EFF;
        font-weight: 600;
      }
    }
    
    .user-info {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 4px;
      transition: all 0.3s;
      
      &:hover {
        background: #f5f7fa;
      }
      
      i {
        font-size: 18px;
      }
      
      span {
        font-size: 14px;
        color: #303133;
      }
    }
  }
  
  // 移动端菜单按钮默认隐藏（桌面）
  .mobile-menu-btn {
    display: none;
  }
}

// 面包屑导航
.breadcrumb-container {
  background: #fff;
  padding: 12px 30px;
  border-bottom: 1px solid #e4e7ed;
  position: relative;
  z-index: 998;

  .breadcrumb-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .category-favorite-star {
    border: none;
    background: transparent;
    padding: 0 2px;
    margin: 0;
    cursor: pointer;
    color: #c0c4cc;
    font-size: 20px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    transition: color 0.2s ease, transform 0.15s ease;

    &:hover:not(:disabled) {
      color: #DC143C;
      transform: scale(1.08);
    }

    &.active {
      color: #DC143C;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    i {
      font-size: 20px;
    }
  }
  
  ::v-deep .el-breadcrumb {
    font-size: 14px;
    
    .breadcrumb-link {
      color: #606266;
      text-decoration: none;
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: #DC143C;
      }
      
      &.breadcrumb-current {
        color: #303133;
        font-weight: 500;
        
        &:hover {
          color: #DC143C;
        }
      }
    }
    
    .breadcrumb-text {
      color: #909399;
      cursor: default;
    }
    
    .breadcrumb-current {
      color: #303133;
      font-weight: 500;
    }
  }
}

.content-wrapper {
  padding: 20px;
}

// 响应式设计
// 平板端（992px以下）
@media (max-width: 992px) {
  .sidebar-nav {
    width: 220px;
    
    .logo-section {
      padding: 15px;
      
      .logo-text {
        font-size: 18px;
      }
    }
    
    .main-nav {
      padding: 15px 0;
      
      .nav-menu .nav-item a {
        font-size: 15px;
        padding: 10px 15px;
      }
    }
  }
  
  .main-content {
    margin-left: 220px;
  }
  
  .top-header {
    padding: 12px 20px;
    
    .header-container {
      gap: 15px;
    }
    
    .user-actions {
      gap: 10px;
      
      .action-btn {
        font-size: 13px;
        padding: 5px 8px;
      }
      
      .user-info {
        font-size: 13px;
        padding: 5px 8px;
      }
    }
  }
  
  .breadcrumb-container {
    padding: 10px 20px;
    font-size: 13px;
  }
  
  .content-wrapper {
    padding: 15px;
  }
}

// 手机端（768px以下）
@media (max-width: 768px) {
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(28, 20, 22, 0.45);
    backdrop-filter: blur(2px);
    z-index: 1002;
    transition: opacity 0.3s ease;
  }
  
  .sidebar-nav {
    width: min(82vw, 300px);
    transform: translateX(-105%);
    transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1);
    z-index: 1000;
    border-radius: 0 18px 18px 0;
    box-shadow: 8px 0 28px rgba(28, 20, 22, 0.18);
    background:
      linear-gradient(180deg, #fff 0%, #fff 48%, #faf7f8 100%);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    
    &.mobile-open {
      transform: translateX(0);
      z-index: 1003;
    }

    .logo-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      padding: 16px 14px 14px 16px;
      border-bottom: none;
      background:
        linear-gradient(135deg, rgba(220, 20, 60, 0.08) 0%, rgba(220, 20, 60, 0.02) 55%, transparent 100%);

      .logo-container {
        align-items: flex-start;
        flex: 1;
        min-width: 0;

        .logo-text {
          font-size: 17px;
          letter-spacing: 0.5px;
          line-height: 1.2;
        }
      }

      .sidebar-close-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        border: none;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.9);
        color: #606266;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        flex-shrink: 0;
        padding: 0;

        i {
          font-size: 16px;
          margin: 0;
        }

        &:active {
          background: #f5f5f5;
          color: #DC143C;
        }
      }
    }

    .main-nav {
      padding: 10px 10px 24px;

      .nav-menu .nav-item {
        margin: 2px 0;

        a {
          padding: 11px 12px;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 500;

          i:first-child {
            width: 22px;
            margin-right: 10px;
            color: #909399;
          }
        }

        &.active a {
          background: rgba(220, 20, 60, 0.1);
          font-weight: 600;

          i:first-child {
            color: #DC143C;
          }

          &::before {
            left: 0;
            width: 3px;
            border-radius: 0 2px 2px 0;
            top: 8px;
            bottom: 8px;
          }
        }

        &.open > a {
          color: #DC143C;
        }

        &.nav-submenu {
          .submenu {
            margin: 4px 0 8px;
            padding: 4px;
            border-radius: 12px;
            background: rgba(245, 247, 250, 0.95);

            li a {
              padding: 10px 12px 10px 34px;
              border-radius: 10px;
              font-size: 13.5px;
            }
          }

          .sub-submenu {
            margin-top: 2px;
            border-radius: 10px;
            background: rgba(233, 236, 239, 0.85);

            .sub-submenu-item > a {
              padding-left: 46px;
              font-size: 13px;
            }
          }

          .sub-sub-submenu {
            border-radius: 10px;

            li a {
              padding-left: 58px;
              font-size: 12.5px;
            }
          }
        }
      }
    }
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .top-header {
    padding: 10px 15px;
    position: sticky;
    top: 0;
    z-index: 1001;
    background: #fff;
    
    .header-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      position: relative;
      align-items: stretch;
    }

    .search-box {
      width: 100%;
      order: 2;
      max-width: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;

      .mobile-menu-btn {
        position: static;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        padding: 0;
        border: 1px solid rgba(220, 20, 60, 0.18);
        border-radius: 12px;
        background: linear-gradient(180deg, #ffffff 0%, #fff7f9 100%);
        box-shadow: 0 2px 8px rgba(220, 20, 60, 0.12);
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

        .menu-btn-lines {
          position: relative;
          width: 18px;
          height: 14px;
          display: block;

          i {
            position: absolute;
            left: 0;
            display: block;
            width: 18px;
            height: 2px;
            border-radius: 2px;
            background: #DC143C;
            transition: transform 0.28s ease, opacity 0.2s ease, top 0.28s ease;

            &:nth-child(1) { top: 0; }
            &:nth-child(2) { top: 6px; width: 14px; }
            &:nth-child(3) { top: 12px; }
          }
        }

        &:active {
          transform: scale(0.96);
        }

        &.is-open {
          background: #DC143C;
          border-color: #DC143C;
          box-shadow: 0 4px 12px rgba(220, 20, 60, 0.28);

          .menu-btn-lines i {
            background: #fff;
            width: 18px;

            &:nth-child(1) {
              top: 6px;
              transform: rotate(45deg);
            }
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              top: 6px;
              transform: rotate(-45deg);
            }
          }
        }
      }
      
      .search-input {
        flex: 1;
        min-width: 0;
        font-size: 14px;
      }
    }
    
    .user-actions {
      order: 1;
      width: 100%;
      justify-content: flex-end;
      margin: 0;
      padding-left: 0;
      display: flex;
      align-items: center;
      gap: 10px;
      
      .action-btn {
        font-size: 12px;
        padding: 6px 10px;
        white-space: nowrap;
        
        i {
          margin-right: 3px;
        }
      }
      
      .user-info {
        font-size: 12px;
        padding: 6px 10px;
        white-space: nowrap;
        
        span {
          font-size: 12px;
        }
      }
    }
  }
  
  .breadcrumb-container {
    padding: 8px 15px;
    font-size: 12px;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
    position: relative;
    z-index: 998;
    margin-top: 0;
    
    ::v-deep .el-breadcrumb {
      font-size: 12px;
      
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          font-size: 12px;
        }
      }
    }
  }
  
  .content-wrapper {
    padding: 10px;
    overflow-x: hidden;
  }
}

// 小屏手机（480px以下）
@media (max-width: 480px) {
  .sidebar-nav {
    width: min(86vw, 280px);
  }
  
  .top-header {
    padding: 8px 10px;
    
    .search-box {
      gap: 6px;

      .mobile-menu-btn {
        width: 38px;
        height: 38px;
        border-radius: 11px;
      }
      
      .search-input {
        font-size: 13px;
      }
    }
    
    .user-actions {
      margin-left: 0;
      padding-left: 0;
      gap: 8px;
      
      .action-btn,
      .user-info {
        font-size: 11px;
        padding: 5px 8px;
        
        i {
          font-size: 14px;
        }
      }
    }
  }
  
  .breadcrumb-container {
    padding: 6px 10px;
    font-size: 11px;
  }
  
  .content-wrapper {
    padding: 8px;
  }
}

// 底部悬浮询价栏（电脑端与手机端统一）
.floating-cart-bar {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  z-index: 1002;
  align-items: center;
  width: min(560px, calc(100% - 24px));
  min-height: 56px;
  padding: 8px 8px 8px 12px;
  background: #2b2b2b;
  border-radius: 28px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  box-sizing: border-box;

  @media (max-width: 768px) {
    left: 12px;
    right: 12px;
    width: auto;
    margin-left: 0;
    margin-right: 0;
  }

  .float-cart-main {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .float-cart-icon-wrap {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #DC143C 0%, #B22222 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;
    font-size: 22px;
  }

  .float-cart-badge {
    position: absolute;
    top: -4px;
    right: -6px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: #fff;
    color: #DC143C;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    box-sizing: border-box;
  }

  .float-cart-info {
    flex: 1;
    min-width: 0;
    color: #fff;
  }

  .float-cart-title {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .float-cart-count {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .float-cart-details {
    font-size: 12px;
    color: #ffb3b3;
    display: inline-flex;
    align-items: center;
    gap: 2px;

    i {
      font-size: 12px;
    }
  }

  .float-cart-sub {
    margin-top: 2px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .float-cart-checkout {
    flex-shrink: 0;
    height: 40px;
    padding: 0 18px;
    margin-left: 8px;
    border: none;
    border-radius: 20px;
    background: #DC143C;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;

    &:active {
      opacity: 0.9;
    }
  }
}

.float-cart-slide-enter-active,
.float-cart-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.float-cart-slide-enter,
.float-cart-slide-leave-to {
  transform: translateY(120%);
  opacity: 0;
}
</style>

<style lang="scss">
body.has-floating-cart {
  padding-bottom: calc(76px + env(safe-area-inset-bottom, 0px));

  .contact-us .contact-us-button {
    bottom: calc(84px + env(safe-area-inset-bottom, 0px));
  }
}
</style>




// WEBPACK FOOTER //
// src/views/home/HomeLayout.vue